import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const QuestionMarkIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="m10.96 13.576-.112-2.368.784-.144q.896-.176 1.312-.576t.416-.96q0-.593-.432-.944-.416-.368-1.216-.368-.656 0-1.136.256-.464.24-.784.56L8.448 7.72q.464-.672 1.344-1.088.896-.432 2.16-.432 1.712 0 2.752.816 1.056.816 1.056 2.304 0 1.072-.624 1.84-.624.752-2.112 1.072l-.176 1.344zm.944 3.664q-.624 0-1.056-.368t-.432-.992.432-.992 1.056-.368 1.056.368.432.992-.432.992-1.056.368"
    />
  </BaseIcon>
)
